module.exports = __webpack_public_path__ + "static/media/TMDBLogo.304596c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainFooter/images/TMDBLogo.svg
// module id = 163
// module chunks = 0